
export const UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION';

export const FETCH_MINISTRIES_START = 'FETCH_MINISTRIES_START';
export const FETCH_MINISTRIES_SUCCESS = 'FETCH_MINISTRIES_SUCCESS';
export const FETCH_MINISTRIES_FAILURE = 'FETCH_MINISTRIES_FAILURE';

export const FETCH_PERMISSIONS_LEVELS_START = 'FETCH_PERMISSIONS_LEVELS_START';
export const FETCH_PERMISSIONS_LEVELS_SUCCESS = 'FETCH_PERMISSIONS_LEVELS_SUCCESS';
export const FETCH_PERMISSIONS_LEVELS_FAILURE = 'FETCH_PERMISSIONS_LEVELS_FAILURE';